import merge from 'lodash/merge';
import psHttp, { generateExceptionRedirector, psAxios } from '@patsnap/common-ps-http';
import { createUniformSetting } from '@patsnap/uniform-setting';
import { HeaderService, SLD, Site } from '@patsnap-utils/biz';
import setWebsiteFont from 'library-components/utils/configure-website-font'
import { getVar } from 'library-components/utils/environment';
import { E_PROJECT_NAME } from 'library-components/config/types';
import { PendoInsertMeta } from 'library-components/services/sentry';

const supports = ['cn', 'en', 'tw', 'jp'];

export async function startup({
    pageInit, zPREFACE = true, embed = true, isLogin,
}) {
    return (Promise.resolve()).then(() => {
        const headerService = new HeaderService();

        return Promise.all([
            headerService.sync({ http: psHttp, uri: process.env.VUE_APP_ACCOUNT_SERVICE_URI }).then((accountInfo) => {
                const setting = createUniformSetting({
                    verbose: true,
                    axiosInstance: psAxios,
                    loggedIn: isLogin,
                    baseAccountUrl: process.env.VUE_APP_ACCOUNT_SERVICE_URI,
                    locale: {
                        supports,
                    },
                });

                return setting.locale.getLocale().then(async({ default: defaultLocale, user }) => {
                    let locale = embed ? getVar('locale') : null;
                    locale = locale || user || defaultLocale;
                    setWebsiteFont(locale);
                    // updateTokenBaseRequestHeaders({ 'X-Site-Lang': locale.toUpperCase() });
                    return [headerService, locale, setting, accountInfo];
                });
            }).catch(console.error),
            ...pageInit
        ]).then((data) => {
            const [[headerService, locale, setting, accountInfo], pageData] = data;
            if (zPREFACE) {
                window.zPREFACE = merge({}, window.zPREFACE, {
                    accountInfo,
                    region: accountInfo.site_region,
                    ...pageData,
                    lang: locale,
                    projectName: E_PROJECT_NAME.Public,
                });
            }

            headerService.title = ''
            if (!isLogin) {
                headerService.visibleProducts = false;
            }
            if (!isLogin) {
                headerService.notificationsVisible = false;
            }

            if (headerService.userCenterService) { // 为了埋点
                const oriBeforeLoginContext = headerService.userCenterService.beforeLogin
                    ? headerService.userCenterService.beforeLogin.bind(headerService.userCenterService)
                    : undefined;
                headerService.userCenterService.beforeLogin = ({ loginHref, logoutHref }) => {
                    if (oriBeforeLoginContext) {
                        // eslint-disable-next-line prefer-rest-params
                        oriBeforeLoginContext(...arguments);
                    }
                    PendoInsertMeta('Login', 'Clicked Login When Register')
                    if (!location.search.includes('noraven=1')) {
                        window.location.href = logoutHref;
                    }
                }
            }

            return [headerService, locale, pageData, setting];
        }).catch(generateExceptionRedirector(403, new Site({ sld: SLD.ACCOUNT, pathname: `user-settings/#/no-permission?from_site=${process.env.VUE_APP_PASSPORT_CLIENT_NAME}` }).href));
    });
}
